import React from 'react';

const RootsSunrise = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;

  return (
    <svg width={`${radius * 2.56}px`} height={`${radius * 1.28}px`} x={`-${radius * 1.28}px`} y={`-${radius * 1.28}px`} viewBox="0 0 256 128" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g>
        <use xlinkHref="#path0_fill" transform="translate(0.0201209 0)" fill={base} />
      </g>
      <defs>
        <path id="path0_fill" d="M 234.343 54.9656L 237.646 60.0357L 213.151 75.8932C 218.937 85.3932 222.933 95.5175 225.236 105.851L 254.053 100.542L 255.163 106.496L 226.378 111.801C 227.223 117.109 227.627 122.452 227.604 127.777L 221.543 127.777C 221.613 110.213 216.734 92.4398 206.442 76.641C 178.302 33.4454 120.148 21.1198 76.821 49.1683C 49.1838 67.0598 34.1505 97.1322 34.1905 127.777L 28.0907 127.777C 28.0842 122.149 28.5536 116.538 29.4858 111.003L 0 104.754L 1.27324 98.8284L 30.6812 105.061C 33.3975 93.3684 38.2033 82.1793 44.9864 72.0683L 20.482 55.2855L 23.9255 50.2967L 48.5189 67.139C 54.6843 59.0669 62.1978 51.828 70.9653 45.7675L 55.0639 21.3582L 60.173 18.0508L 76.0744 42.4601C 85.8115 36.5746 96.1821 32.5369 106.777 30.2604L 101.356 1.10677L 107.329 0L 112.765 29.1772C 123.422 27.5628 134.246 27.6972 144.753 29.5084L 150.592 2.16336L 156.528 3.42149L 150.709 30.7201C 161.5 33.2506 171.872 37.5578 181.357 43.5427L 199.019 17.943L 204.024 21.3763L 186.409 46.9454C 195.303 53.3629 203.273 61.3486 209.86 70.8155L 234.343 54.9656Z" />
      </defs>
    </svg>
  )
}
export default RootsSunrise;

export function resize(props) {
  const { radius, minY, minX, maxY, maxX } = props;
  return {
    ...props,
    minY: minY + radius * .3,
    minX: minX + radius * .3,
    maxX: maxX + radius * .3,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/sunrise.js